/**
 * usePointsToast Hook
 * Displays animated toast notifications for point awards
 */

import { useToast } from '@/global/components/ui/use-toast';
import { getReasonDisplayText, getReasonEmoji } from '../lib/pointsService';

interface PointsToastOptions {
  points: number;
  reason: string;
  totalPoints?: number;
}

export function usePointsToast() {
  const { toast } = useToast();

  const showPointsToast = ({
    points,
    reason,
    totalPoints,
  }: PointsToastOptions) => {
    const emoji = getReasonEmoji(reason);
    const reasonText = getReasonDisplayText(reason);

    toast({
      title: `${emoji} +${points} Points!`,
      description: totalPoints
        ? `${reasonText} • Total: ${totalPoints.toLocaleString()} points`
        : reasonText,
    });
  };

  const showLimitReachedToast = (reason: string) => {
    const reasonText = getReasonDisplayText(reason);

    toast({
      title: '⏰ Daily Limit Reached',
      description: `You've reached the daily limit for ${reasonText}. Try again tomorrow!`,
    });
  };

  const showErrorToast = (error: string) => {
    toast({
      title: '❌ Points Award Failed',
      description: error,
      variant: 'destructive',
    });
  };

  return {
    showPointsToast,
    showLimitReachedToast,
    showErrorToast,
  };
}
